export default __webpack_public_path__ + "static/abaca-resort-1aac49a2d67c1e58cdc5f8e0b69629e6.png";